import React, {useState} from 'react'
import {ScrollTest, TitleAniLeft} from '../../component/ScrollTest';
import { useLanguage } from '../../i18n/LanguageContext'

const EXPERIENCE = {
  ja: [
    {
      period: '2024  -- 現在',
      company: '嘉實資訊股份有限公司',
      projects: [
        {
          title: 'ファンド・ETF情報ページ改修案を担当（React、C#）',
          details: [
            'ファンド・ETF情報ページを担当（収藏・比較・申購（購入申込）などの機能を含む）。',
            '-- デザイン、基礎アーキテクチャ、一部ページの実装を担当',
            '-- AIとUI/UXの設計方針について議論しながら進行',
            '-- 過去の顧客対応経験を踏まえ、表示すべき項目を決定',
            '-- API（C#）の実装',
            '-- 本プロジェクトではMUIを使用',
            { type: 'link', prefix: '-- サイト：', url: 'https://b2bfundrwdtest.moneydj.com/nextfundetf/fund/demo' },
          ],
        },
        {
          title: 'ファンドスーパーマーケット関連ページの構築を担当（React、C#）',
          details: [
            'ファンド情報ページを担当（個別ファンド紹介、一覧、検索機能を含む）。',
            '-- マークアップ、基礎アーキテクチャ、全ページの実装を担当',
            '-- API（C#）の実装',
            '-- 本プロジェクトではMUI及び自作コンポーネントを使用',
          ],
        },
        {
          title: '顧客（銀行・証券会社）委託によるページ構築を担当（React、JS/TS、asp、C#）',
          details: [
            '既存のファンド・ETF・債券・海外株式などのページに、顧客ごとのカスタマイズを実装。',
            '顧客側で埋め込めるiframeリンクを提供。サイト全体を委託された場合は、まるごと構築。',
            '-- マークアップ、基礎アーキテクチャ（旧JSからReactへの移行）、全ページの実装を担当',
            '-- API（C#）の実装',
            '-- 旧バージョンのファンド・ETF情報ページのカスタマイズ（asp）',
            '-- 本プロジェクトではBootstrap、jQuery及び自作コンポーネントを使用',
            { type: 'link', prefix: '-- 全部委託の例：', url: 'https://feibbank.moneydj.com/' },
          ],
        },
        {
          title: '顧客（銀行・証券会社）委託による脆弱性診断修正を担当（React、JS/TS、asp、Bootstrap、jQuery、C#、CSP）',
          details: [
            '自社が提供している顧客サイトの脆弱性を、半年ごとまたは四半期ごとに修正。',
            '顧客によって対象範囲や使用言語が異なり、大半はaspで構築されたサイト。',
            '-- CSPの調整、IIS設定の追加など',
            '-- Bootstrap、jQueryのバージョンアップ',
            '-- サイト全体のテスト',
          ],
        },
        {
          title: '顧客（銀行・証券会社）委託による情報ソース提供を担当（asp、C#）',
          details: [
            'ファンド基準価額、株式時価などの情報ソースを提供。',
            '-- 項目の調整などを担当',
            '-- FTP経由で顧客のファンドリストファイルを受け取り、データを変換してDBに保存後、APIまたはファイル連携で提供',
          ],
        },
        {
          title: '自社製品及び顧客（証券会社）委託によるアプリ向けページを担当（React、C#）',
          details: [
            '株式引け後情報ページを提供（三大法人動向、株主総会記念品情報など）。',
            '-- 項目調整、新規ページ制作などを担当',
            '-- TypeScriptでnpmパッケージを開発・公開し、アプリ側で連携（例：アプリ内の他ページへの遷移リンクなど）',
          ],
        },
      ],
    },
    {
      period: '2022  -- 2024',
      company: '華能平方股份有限公司',
      projects: [
        {
          title: '食品薬物管理署（FDA）内部許可証関連システム改修案を担当（React）',
          details: [
            'フォームやCRUD（登録・削除・修正・検索）機能を多く含むシステム。化粧品と医薬品の2つの領域に分かれており、実質的に2つのシステムを兼ねる。',
            '社内で必要な承認・決裁フローも含む。',
            '-- ゼロからの立ち上げで、マークアップ、基礎アーキテクチャ、大部分のページ実装を担当',
            '-- デザイナーが用意していなかった画面やボタンなどのデザインも担当',
            '-- 一部UX設計も担当',
            '-- 本プロジェクトではMUIを使用',
          ],
        },
        {
          title: '食品薬物管理署（FDA）外部向け一般照会システム改修案に参加（React）',
          details: [
            '-- 一部ページの実装に参加',
            '-- ウェブアクセシビリティ AA 等級に対応するよう改修',
            { type: 'link', prefix: '-- サイト：', url: 'https://lmspiq.fda.gov.tw/web/' },
          ],
        },
        {
          title: '経済部内部システムダッシュボードのフロントエンドを担当（React）',
          details: [
            '最新情報や未処理文書数などを表示するダッシュボードを担当。よく使うシステムをリストから選択・更新可能。',
            '管理職はユーザー切り替え機能を使って部下の未処理状況を確認でき、切り替えたユーザーに応じて異なる閲覧権限が適用される。',
            '-- 文字サイズ（大・中・小）切り替え、ライト／ダークモード切り替えに対応',
            '-- マークアップ及びほぼ全機能の実装を担当',
          ],
        },
        {
          title: '知的財産局「マイダッシュボード」を担当（Angular）',
          details: [
            '特許・商標の申請状況や納付状況、履歴照会などを行う専用サイト。',
            '-- マークアップ及びリリース後の機能保守を担当',
            '-- デザインにも一部参加',
            '-- RWD対応（スマートフォン、タブレット、ノートPC、24インチモニターに対応）',
            { type: 'link', prefix: '-- サイト：', url: 'https://www.tipo.gov.tw/tw/cp-85-918103-4e2b8-1.html' },
          ],
        },
        {
          title: '労働部財産管理システムの改修・増修案に参加（Angular）',
          details: [
            '労働部及び台湾全土の下部機関が使用する、土地・建物・動産などを管理するシステム。新規登録、異動、移動、検索、月次締め、承認などの機能を含む。',
            '-- 8つの資産分類のうち2分類、全レポートダウンロードページ、システム保守ページを担当',
          ],
        },
      ],
    },
    {
      period: '2021  -- 2022',
      company: '卒業制作',
      projects: [
        {
          title: '学内卒業制作（プログラム担当）',
          details: [
            '5人チームでゲームを制作',
            '-- もう1名のメンバーと共にプログラムを担当',
            '-- UX設計も担当',
            '-- 他者と一緒にコードを書くのが初めてで、コンフリクトだらけだった',
            '-- 「放視大賞」への出展はとても楽しい経験だった',
          ],
        },
      ],
    },
    {
      period: '2020  -- 2021',
      company: '専題制作',
      projects: [
        {
          title: '学内専題制作（プログラム担当）',
          details: [
            '3人チームでゲームを制作',
            '-- プログラム、企画を担当',
            '-- 美術以外のデザイン全般を担当',
          ],
        },
      ],
    },
    {
      period: '2018  -- 2022',
      company: 'アルバイト時代',
      projects: [
        {
          title: '',
          noToggle: true,
          details: [
            '飲料店の店員、歯科助手、小売店員、QAテスト実習生などを経験',
          ],
        },
      ],
    },
  ],
  zh: [
    {
      period: '2024  -- 現在',
      company: '嘉實資訊股份有限公司',
      projects: [
        {
          title: '負責基金與ETF資訊頁面改版案（React、C#）',
          details: [
            '基金與ETF資訊頁面，包括收藏、比較、申購等功能。',
            '-- 包含設計、基礎架構及部分頁面',
            '-- 和AI討論UIUX的設計方式',
            '-- 透過過往與客戶來往的經驗，決定需要呈現的欄位',
            '-- api (C#) 撰寫',
            '-- 此專案使用MUI',
            { type: 'link', prefix: '-- 網站：', url: 'https://b2bfundrwdtest.moneydj.com/nextfundetf/fund/demo' },
          ],
        },
        {
          title: '負責基金超市相關頁面建置（React、C#）',
          details: [
            '基金資訊頁面，包括單基金介紹、列表、查詢。',
            '-- 包含套版、基礎架構及所有頁面',
            '-- api (C#) 撰寫',
            '-- 此專案使用MUI以及自行撰寫的元件',
          ],
        },
        {
          title: '負責客戶(銀行、證券端)委託之頁面建置（React、JS/TS、asp、C#）',
          details: [
            '將現有的基金、ETF、債券、外國股票等頁面加上客製化。',
            '提供iframe連結供客戶串接，若是整個網站都委託給我們，就會是直接做到好。',
            '-- 包含套版、基礎架構 (將舊有JS改成react) 及所有頁面',
            '-- api (C#) 撰寫',
            '-- 舊版基金、ETF資訊頁的客製化 (asp)',
            '-- 此專案使用Bootstrap、jQuery以及自行撰寫的元件',
            { type: 'link', prefix: '-- 全部委託的範例：', url: 'https://feibbank.moneydj.com/' },
          ],
        },
        {
          title: '負責客戶(銀行、證券端)委託之弱點掃描修復（React、JS/TS、asp、Bootstrap、jQuery、C#、CSP）',
          details: [
            '修補由我們提供的客戶網站的弱點，每半年或每季一次。',
            '不同的客戶會有不同的範圍及語言，大部分是asp。',
            '-- 包含CSP調整、IIS增加設定等等',
            '-- Bootstrap、jQuery升版',
            '-- 網站整體測試',
          ],
        },
        {
          title: '負責提供客戶(銀行、證券端)委託之資訊源（asp、C#）',
          details: [
            '提供如基金淨值、股票市價等等資訊源。',
            '-- 包含欄位調整等',
            '-- 從FTP接客戶的基金清單檔案並轉檔存至DB，再以api或拋檔方式提供',
          ],
        },
        {
          title: '負責提供自家產品與客戶(證券端)委託之app頁面（react、C#）',
          details: [
            '提供股票盤後頁面，例如：三大法人、股東會紀念品等等',
            '-- 包含欄位調整、新頁面製作等',
            '-- 用typescript寫npm套件並發布，app再寫串接，例如：連結跳至app其他頁面等',
          ],
        },
      ],
    },
    {
      period: '2022  -- 2024',
      company: '華能平方股份有限公司',
      projects: [
        {
          title: '負責食藥署內部許可證相關系統改版案（React）',
          details: [
            '一個充滿表單及增刪修查的系統。分為醫粧及藥品兩大部分（所以其實是兩個系統）。',
            '包含內部所需的簽核流程',
            '-- 從零開始，包含切版、基礎架構及大部分頁面',
            '-- 設計設計師沒有設計的畫面、按鈕等',
            '-- 部分UX的設計',
            '-- 此專案使用MUI',
          ],
        },
        {
          title: '參與食藥署外網民眾查詢系統改版案（React）',
          details: [
            '-- 參與部分頁面製作',
            '-- 將其修改成無障礙網頁AA級',
            { type: 'link', prefix: '-- 網站：', url: 'https://lmspiq.fda.gov.tw/web/' },
          ],
        },
        {
          title: '負責經濟部內部系統儀表板的前端（React）',
          details: [
            '主要為顯示最新消息、未處理公文數等等的儀表板。可從列表挑選並更新常用系統。',
            '主管可以利用切換人員的功能，查看員工的未處理狀況，依照切換的人員，擁有不同的查看權限。',
            '-- 字體大、中、小切換，亮色、暗色模式切換',
            '-- 包含切版以及幾乎所有功能',
          ],
        },
        {
          title: '負責智慧局「我的儀表板」（Angular）',
          details: [
            '一個查看專利、商標申請情況及繳費、查詢歷史紀錄等等的專用網站',
            '-- 網頁切版、後期功能方面維護',
            '-- 參與設計',
            '-- 含RWD，手機、平板、筆電與24吋螢幕',
            { type: 'link', prefix: '-- 網站：', url: 'https://www.tipo.gov.tw/tw/cp-85-918103-4e2b8-1.html' },
          ],
        },
        {
          title: '參與勞動部財產系統的改版增修案（Angular）',
          details: [
            '勞動部及其全台所有下屬機關使用的，土地、建物、動產等等的管理系統，包括新增、異動、移動、查詢、月結帳、簽核等',
            '-- 負責八大類別的其二、所有報表下載頁面、系統維護頁面',
          ],
        },
      ],
    },
    {
      period: '2021  -- 2022',
      company: '畢業製作',
      projects: [
        {
          title: '校內畢業製作（程式）',
          details: [
            '五人一組一起寫遊戲',
            '-- 和另一位組員一起負責程式',
            '-- UX的設計擔當',
            '-- 第一次和他人一起寫程式，code滿滿的衝突',
            '-- 到放視大賞參展很有趣',
          ],
        },
      ],
    },
    {
      period: '2020  -- 2021',
      company: '專題製作',
      projects: [
        {
          title: '校內專題製作（程式）',
          details: [
            '三人一組一起寫遊戲',
            '-- 負責程式、企劃',
            '-- 除了美術以外的設計擔當',
          ],
        },
      ],
    },
    {
      period: '2018  -- 2022',
      company: '工讀時代',
      projects: [
        {
          title: '',
          noToggle: true,
          details: [
            '從事過飲料店員、牙醫助理、零售店員以及QA測試實習生',
          ],
        },
      ],
    },
  ],
}

function flattenExperience(jobs) {
  const rows = []
  let count = 0
  jobs.forEach((job, jobIndex) => {
    rows.push({ type: 'header', key: `h-${jobIndex}`, period: job.period, company: job.company })
    job.projects.forEach((project, projectIndex) => {
      const toggleIndex = project.noToggle ? null : count
      if (!project.noToggle) count += 1
      rows.push({ type: 'project', key: `p-${jobIndex}-${projectIndex}`, ...project, toggleIndex })
    })
  })
  return { rows, count }
}

function renderDetailItem(detail, key) {
  if (detail && typeof detail === 'object' && detail.type === 'link') {
    return (
      <span key={key}>
        {detail.prefix}
        <a className='expLink' href={detail.url} target='_blank' rel='noopener noreferrer'>{detail.url}</a>
      </span>
    )
  }
  return <span key={key}>{detail}</span>
}

function getInitialExpand(count) {
    const initial = Array(count).fill(false)
    const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 960px)').matches
    if (isMobile && count > 0) {
        initial[0] = true
    }
    return initial
}

export default function Experience() {
    const { lang } = useLanguage()
    const jobs = EXPERIENCE[lang]
    const { rows, count } = flattenExperience(jobs)
    const [expandDetail, setExpandDetail] = useState(() => getInitialExpand(count));

    const expandDetailChange = (index) => {
        setExpandDetail(prev => {
            const next = [...prev]
            next[index] = !prev[index]
            return next
        })
    }
  return (
    <div>
        <section className="experience" id="experience">
            <TitleAniLeft title='My' title2='experience'/>
            <br/>
            <div className='box-container'>
                {rows.map((row) => {
                    if (row.type === 'header') {
                        return (
                            <div className='box-content' key={row.key}>
                                <div className='left'>
                                    <p>★</p>
                                </div>
                                <div className='center'>
                                    <p>{row.period}</p>
                                </div>
                                <div className='right'>
                                    <p>{row.company}</p>
                                </div>
                            </div>
                        )
                    }
                    const isOpen = row.toggleIndex === null ? true : expandDetail[row.toggleIndex]
                    return (
                        <ScrollTest
                            key={row.key}
                            title={
                                <div className='box-content'>
                                    <div className='left'>
                                        <p></p>
                                    </div>
                                    <div className='center' onClick={row.toggleIndex === null ? undefined : () => expandDetailChange(row.toggleIndex)}>
                                        <div>
                                            <span>{row.title}</span>
                                        </div>
                                    </div>
                                    <div className={`right ${isOpen ? '': ' displayNone'}`}>
                                        <div>
                                            {row.details.map((detail, di) => renderDetailItem(detail, di))}
                                        </div>
                                    </div>
                                </div>
                            }/>
                    )
                })}
            </div>
        </section>
    </div>
  )
}
